import {
    EXECUTE_IMPORT_XLSX_DOCUMENT_REQUEST,
    EXECUTE_IMPORT_XLSX_DOCUMENT_SUCCESS,
    EXECUTE_IMPORT_XLSX_DOCUMENT_FAILURE,
    EXECUTE_IMPORT_DEFAULT,
} from '../../actions/import/execute-import-actions';

const initialState = {
    result: null,
    isLoading: false,
    error: null,
};

const ExecuteImportReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case EXECUTE_IMPORT_XLSX_DOCUMENT_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case EXECUTE_IMPORT_XLSX_DOCUMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                result: { ...action.payload },
            };
        case EXECUTE_IMPORT_XLSX_DOCUMENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            case EXECUTE_IMPORT_DEFAULT:
                return initialState
        default:
            return state;
    }
};

export default ExecuteImportReducer;